import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/parker-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-parker-colorado",
      statusCode: 301,
    });
  },
});
